module.exports = __webpack_public_path__ + "static/media/wavm8s-015-dj-animebby.c01a20f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-015-dj-animebby.mp3
// module id = NYmg
// module chunks = 0